<template>
  <VWidget
    :title="$t('Group')"
    class="mb-4"
  >
    <div slot="widget-header-action">
      <v-spacer/>
      <v-tooltip
        bottom
      >
        <template v-slot:activator="{ on }">
          <v-icon
            class="pointer"
            color="primary"
            dark
            v-on="on"
          >
            info
          </v-icon>
        </template>
        <span v-html="$t('Customer Groups allowed to use this promotion. <br> Leave empty to allow everyone.')"/>
      </v-tooltip>
    </div>
    <div slot="widget-content">
      <v-layout
        wrap
        row
      >
        <v-flex xs12>
          <div slot="widget-content">
            <v-autocomplete
              v-model="item.customer_group"
              :items="groups"
              :label="$t('Customer Group')"
              multiple
              item-text="name"
              item-value="code"
              outline
            />
          </div>
        </v-flex>
      </v-layout>
    </div>
  </VWidget>
</template>

<script>
export default {
  name: 'DiscountCustomerGroups',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      groups: []
    }
  },

  async mounted () {
    this.groups = await this.$http.make('customer:group').get()
  }
}
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>
